
import { Vue, Component } from 'vue-property-decorator';

@Component({

})
export default class AboutMe extends Vue {
  get isCommerce(): boolean {
    return this.$store.state.registration.isCommerce;
  }

  set isCommerce(value: boolean) {
    this.$store.commit('setCommerce', value);
  }

  private submit(): void {
    this.$emit('next');
  }
}
